
import 'components/catalog.tag'
import './brand-new-modal.tag'
riot.tag2('brands-list', '  <catalog search="true" sortable="true" object="Brand" cols="{cols}" reorder="true" allselect="true" reload="true" store="brands-list" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(brandOpen, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="img"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-width: 200px;"></datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n    </yield>\n  </catalog>\n', 'brands-list .table td,[riot-tag="brands-list"] .table td,[data-is="brands-list"] .table td{ vertical-align: middle !important; }', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Brand';

self.cols = [{ name: 'id', value: '#', width: '50px' }, { name: 'img', value: 'Логотип' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'URL' }];

self.add = function (e) {
    modals.create('brand-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var params = { name: _this.name.value };
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'Brand',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        popups.create({ title: 'Успех!', text: 'Бренд добавлен!', style: 'popup-success' });
                        _this.modalHide();
                        observable.trigger('brands-reload');
                    }
                });
            }
        }
    });
};

self.brandOpen = function (e) {
    riot.route('/products/brands/' + e.item.row.id);
};

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'Brand',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });
        self.update();
    });
});

observable.on('brands-reload', function () {
    //self.tags.catalog.reload()
});
});


// WEBPACK FOOTER //
// ./pages/products/brands/brands-list.tag